import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ExpanderComponent } from '../expander/expander.component';
import { mainConfiguration } from '../../../configuration/main';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { UnitTypeToggleComponent } from '../../../components/unit-type-toggle/unit-type-toggle.component';
import { HeaderSpinnerService } from '../../../services/header.spinner.service';
import { SimulationService } from '../../../services/simulation.service';
import { CompanyFeService } from '../../../services/companyfe.service';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectFeService } from '../../../services/projectfe.service';
import { CompanyDTO, ModuleService, SelectOptionModel, UnitType } from '../../../openapi';
import { EnvironmentService } from '../../../services/environment.service';
import { UserAuthService } from '../../services/user-auth.service';
import { Router } from '@angular/router';
import { DesktopSyncService } from '../../../features/desktop-sync/services/desktop-sync.service';
import { DeepLinkService } from '../../../services/deep-link.service';
import { UnitConversionService } from '../../../services/unit-conversion.service';

@Component({
  selector: 'adf-global-application-toolbar',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDropdownModule, ExpanderComponent, UserMenuComponent, TranslateModule, UnitTypeToggleComponent],
  templateUrl: './global-application-toolbar.component.html',
  styleUrl: './global-application-toolbar.component.scss',
})
export class GlobalApplicationToolbarComponent implements OnInit {
  private readonly _userAuthService = inject(UserAuthService);
  readonly _headerSpinnerService = inject(HeaderSpinnerService);
  readonly _simulationService = inject(SimulationService);
  readonly _companyFeService = inject(CompanyFeService);
  readonly _projectFeService = inject(ProjectFeService);
  readonly _environmentService = inject(EnvironmentService);
  readonly _desktopSyncService = inject(DesktopSyncService);
  private readonly _router = inject(Router);
  readonly _deepLinkService = inject(DeepLinkService);
  readonly _moduleService = inject(ModuleService);
  readonly _unitService = inject(UnitConversionService);

  isNotError = true;
  isSettingsLoaded = false;
  title = mainConfiguration.title;
  userName = '';
  isElectron = false;
  isModuleDeveloper = false;

  companyList: SelectOptionModel[] = [];
  dbCompany: CompanyDTO[] = [];
  isOnline = navigator.onLine;

  ngOnInit(): void {
    this.isElectron = this._environmentService.isElectron();

    this.refreshOnChange();

    this._userAuthService.getUserUpdated().subscribe(updated => {
      if (updated) {
        this.refreshOnChange();
      }
    });
  }

  refreshOnChange() {
    this._userAuthService.getCurrentUser().subscribe(user => {
      if (user) {
        this.userName = user?.name ?? '';
        this.isModuleDeveloper = this._userAuthService.userRoles.some(x =>
          x.policys?.some(p => p.name?.toLowerCase().includes("developer")) ?? false
        );

        this._unitService.setSystem(this._userAuthService.userUnitSystem || UnitType.Metric);

        this._moduleService.apiModuleGetModulesForUserGet().subscribe(modules => {
          this._companyFeService.companysModules = modules;

          if(this._deepLinkService.hasPendingUrl()) {
              this._deepLinkService.setCompany();
            } else {
              this._companyFeService.onSelectedCompany();
            }
        });
      }
    });
  }

  onLogout() {
    this._userAuthService.logout();
  }

  onSync() {
    this._router.navigate(['/desktop-sync']);
  }
}
